import { Fragment } from 'react';

import { IPFS_URL } from '../../app/constants';
const Card = ({
  image,
  name,
  video,
  rarities,
  bestRarity,
  notInUserWallet,
  mp,
}) => {
  const nameStr = name.replace(/ /g, '%20')
  const format = (num, decimals = 2) =>
    num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })

  return (
    <div className="flex flex-col pb-3">
      <div className="flex gap-2">
        <div
          className={
            notInUserWallet ? 'col-span-2 filter grayscale ' : 'col-span-2'
          }
        >
          {video ? (
            <video
              autoPlay
              width={150}
              height={200}
              loop
              muted
              src={
                video.startsWith('Q') ? `${IPFS_URL}${video}` : video
              }
              loading="lazy"

            ></video>
          ) : (
            <img
              alt={name}
              width={150}
              height={200}
              src={
                image.startsWith('Q') ? `${IPFS_URL}${image}` : image
              }
              loading="lazy"
            ></img>
          )}
        </div>
        <div>
          <dl className="text-white">
            {rarities
              ? rarities.map(({ name, quantity }) => (
                  <Fragment key={name}>
                    <dd className="inline-block pl-1">
                      {quantity < 10 ? `0${quantity}` : quantity}
                    </dd>
                    <dt className="inline-block w-fit pl-2 text-gold">
                      {name}
                    </dt>
                    <br />
                  </Fragment>
                ))
              : null}
          </dl>
        </div>
      </div>
      <div>
        {/* <h3 className="text-white pt-2">{name}</h3> */}{' '}
        {/* Names removed to follow figma */}
        {!notInUserWallet && (
          <dl>
            <dt className="text-gold inline-block w-fit">Best Rarity: </dt>
            <dd className="text-white inline-block pl-1">{bestRarity}</dd>
            <br />
            <dt className="text-gold inline-block w-fit">Total MP: </dt>
            <dd className="text-white inline-block pl-1">{format(mp || 0)}</dd>
          </dl>
        )}
        <div className="text-cyanBlue">
          <a
            href={`https://wax.atomichub.io/market?collection_name=galaktikanft&match=${nameStr}&order=desc&sort=created&symbol=WAX`}
            target="_blank"
            rel="noreferrer"
          >
            Trade
          </a>
        </div>
      </div>
    </div>
  )
}

export default Card
